import api from 'src/config/api';
import {
	IGetSitesResponse,
	IGetSitesRequestParams,
	ICreateSiteRequest,
	ISite,
	ISiteDetails,
	IUpdateSiteRequest,
} from 'src/features/site/domain/types';

export const siteApi = {
	getSites: async (
		requestParams: IGetSitesRequestParams,
	): Promise<IGetSitesResponse> => {
		const { page = 1, search } = requestParams;

		const params = new URLSearchParams({
			page: page.toString(),
			...(search && { search }),
		});

		const response = await api.get(`/api/v1/sites?${params}`);
		return response.data;
	},

	createSite: async (requestBody: ICreateSiteRequest): Promise<ISite> => {
		const response = await api.post('/api/v1/site', requestBody);
		return response.data;
	},

	getSiteDetails: async (siteSlug: string): Promise<ISiteDetails> => {
		const response = await api.get('/api/v1/site', {
			headers: {
				Site: siteSlug,
			},
		});
		return response.data;
	},

	updateSite: async (
		requestBody: IUpdateSiteRequest,
		siteSlug: string,
	): Promise<ISite> => {
		const response = await api.patch('/api/v1/site', requestBody, {
			headers: { Site: siteSlug },
		});
		return response.data;
	},

	deleteSite: async (siteSlug: string): Promise<void> => {
		await api.delete('/api/v1/site', {
			headers: { Site: siteSlug },
		});
		return;
	},
};
